<template>
  <v-menu
    :disabled="disabled"
    :eager="true"
  >
    <template #activator="{ props: menuProps, isActive }">
      <menu-btn
        v-bind="menuProps"
        ref="menu-activator"
        :icon="menuProps.icon ? isActive ? 'x' : '$bars' : false"
        :active="isActive"
        height="40"
        class="rounded-1 lg:px-4 xl:px-5 text-body-xs font-bold"
        :class="{ 'bg-black-4': isHovering || isActive }"
        base-color="type-primary"
        active-color="link-primary"
      >
        <template
          v-if="!menuProps.icon && !disabled"
          #append
        >
          <v-icon
            class="-ms-1"
            size="16"
            :icon="isActive ? 'caret-up-bold' : 'caret-down-bold'"
          />
        </template>
      </menu-btn>
    </template>

    <template #default="props">
      <slot v-bind="props" />
    </template>
  </v-menu>
</template>

<script setup lang="ts">
defineProps<{
  disabled?: boolean
}>()

const activatorRef = useTemplateRef<HTMLButtonElement>('menu-activator')
const isHovering = useElementHover(activatorRef)
</script>
